/* eslint-disable */
import * as d3 from 'd3'

const util = {}

util.addLaunchAngle = function addLaunchAngle(playData) {
    const metrics = playData?.result?.computedMetrics

    if (!metrics) {
        playData.result = {
            computedMetrics: {
                exitVelocity: { value: 0 },
                projectedDistance: { value: 0 },
                launchAngle: { value: 0 },
            },
        }
        return
    }
    const angle = metrics.launchAngle

    // if already exists, do nothing
    if (angle) {
        return
    }

    // otherwise, calculate angle
    const { path } = playData.result.hit
    // points = d3.range(0, path.length / 3).map(function (i) {
    // first 3 points - first 2 okay instead?
    const points = d3.range(3).map((i) => {
        const j = 3 * i

        return {
            x: path[j],
            y: path[j + 1],
            z: path[j + 2],
        }
    })
    const p0 = points[0]
    const p2 = points[2]
    const delta = (function (p, q) {
        return {
            x: q.x - p.x,
            y: q.y - p.y,
            z: q.z - p.z,
        }
    })(p0, p2)
    const d = Math.sqrt(delta.x * delta.x + delta.y * delta.y)
    const radians = Math.atan2(delta.z, d)

    metrics.launchAngle = {
        value: (radians * 180) / Math.PI,
        unit: 'degrees',
    }

    return this
}

util.addMaxHeight = function addMaxHeight(playData) {
    const metrics = playData?.result?.computedMetrics

    const { path } = playData?.result?.hit || {}

    if (!metrics || !path) {
        return this
    }
    const z = path.filter((d, i) => (i + 1) % 3 === 0)

    metrics.maxHeight = {
        value: d3.max(z),
        unit: 'feet',
    }

    return this
}

export default util
